module.exports = __webpack_public_path__ + "static/team-jacob-962a5db8bee9d71614295bc4f67d528c.jpg";